import React, { useCallback, useEffect, useState } from "react";
import {
    Banner,
    Button,
    Card,
    Divider,
    Text,
    Select,
    Spinner,
    TextField,
    Label,
} from "@shopify/polaris";
import { ToastContainer, toast } from "react-toastify";
import { defaultAppIcon } from "../../../../assets";
import DevImageList from "../../../dev_components/dev_image_list/dev_image_list";
import DevUploadBanner from "../../../dev_components/dev_upload_banner/dev_upload_banner";
import { useDispatch, useSelector } from "react-redux";
import {
    getAppOverViewDetails,
    listOfCategory,
    saveconfigurationsApi,
} from "../../../dev_services/developer/api";
import {
    fetchDataStart,
    fetchDataSuccess,
} from "../../../dev_store/slice/apps_overview_slice/apps_overview_slice";
import { useParams } from "react-router-dom";
import DevUploadIcon from "../../../dev_components/dev_upload_banner/dev_upload_icon";
import { Category } from "@mui/icons-material";
import "../app_listing/app_listing.scss"

export default function AppListing() {
    const { appID } = useParams();
    const dispatch = useDispatch();
    const [appName, setAppName] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [appTitle, setAppTitle] = useState("");
    const [appIconUrl, setAppIconsUrl] = useState("");
    const [appDescription, setAppDescription] = useState("");
    const [submitStatus, setSubmitStatus] = useState("");
    const [banners, setBanners] = useState([]);
    const [contactNumber, setContactNumber] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [supportUrl, setsupportUrl] = useState("");
    const [contactNumberError, setContactNumberError] = useState("");
    const [contactEmailError, setContactEmailError] = useState("");
    const [supportUrlError, setSupportUrlError] = useState("");
    const [titleTag, settitleTag] = useState("");
    const [titleTagError, setTitleTagError] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [metaDescriptionError, setMetaDescriptionError] = useState("");


    const [selectedResponseCategory, setSelectedResponseCategory] = useState<
        { id: string; name: string }[]
    >([]);
    const [selectedCategory, setSelectedCategory] = useState<
        { id: string; name: string }[]
    >([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [features, setFeatures] = useState<string[]>([]);
    const [featureValues, setFeatureValues] = useState<string[]>([]);
    const [selectedLanguage, setSelectedLanguage] = useState("English");
    const appsResponseData = useSelector((state: any) => state.appsOverviewSlice);
    const { data, loading, error } = appsResponseData;
    const [appNameError, setAppNameError] = useState("");
    const [shortDescriptionError, setShortDescriptionError] = useState("");
    const [appTitleError, setAppTitleError] = useState("");
    const [appDescriptionError, setAppDescriptionError] = useState("");
    const MAX_FEATURES = 10;
    const updatedFeaturesList = features
        .filter((feature) => feature.trim() !== "") // Remove empty features
        .slice(0, MAX_FEATURES) // Limit features to maximum allowed
        .map((feature, index) => ({ description: feature }));

    const fetchDataCategory = async () => {
        try {


            const categoryApiResponse = await listOfCategory();

            try {

                if (
                    categoryApiResponse?.list_of_category &&
                    categoryApiResponse.list_of_category.length > 0
                ) {
                    setSelectedCategory(categoryApiResponse.list_of_category);
                    console.log(
                        "Selected categories set:",
                        categoryApiResponse.list_of_category
                    );
                } else {
                    console.error("Category list not found in API response");
                    // Handle the case when the category list is not available in the API response
                }
            } catch (e: any) {
                toast.error(e);
            }
            //  setSelectedCategory(response.data.list_of_categories);
            // setSelectedLanguage(response.data.selectedLanguage);
        } catch (error) {
            toast.error("Error fetching data");
        }
    };



    useEffect(() => {
        const fetchData = async () => {
            try {

                dispatch(fetchDataStart());

                // Fetching data from the API
                const response = await getAppOverViewDetails(appID);
                const categoryApiResponse = await listOfCategory();

                const slugName = response.slug;
                localStorage.setItem("slug", slugName);
                dispatch(fetchDataSuccess(response));

                try {
                    setAppName(response?.data?.app_name);
                    setShortDescription(response?.data?.short_description);
                    setAppTitle(response?.data?.app_info.title);
                    setAppDescription(response?.data?.app_info.description);
                    setBanners(response?.data?.banners);
                    setSelectedResponseCategory(response?.list_of_categories);


                    setSelectedLanguage(response?.data?.selectedLanguage);
                    const supportNumber = response?.data?.support_info?.support_number;
                    if (supportNumber) {
                        // Check if the support number starts with "+91"
                        const formattedSupportNumber = supportNumber.startsWith("+91")
                            ? supportNumber.substring(3)
                            : supportNumber;
                        setContactNumber(formattedSupportNumber);
                    } else {
                        // If the support number is null or undefined, set an empty string
                        setContactNumber("");
                    }
                    setSubmitStatus(response?.data?.status || "");
                    setContactEmail(response?.data?.support_info.support_email);
                    setsupportUrl( response?.data?.support_info?.support_url)
            
                    settitleTag(response?.data?.seo_details?.title_tag)
                    setMetaDescription(response?.data?.seo_details?.meta_description)

                    const fetchedFeatures: string[] = response?.app_info?.features || [];
                    setFeatures(fetchedFeatures);
                    setFeatureValues(fetchedFeatures.map(() => ""));
                    setAppIconsUrl(response?.app_info?.app_url);
                    // console.log("url image" + response?.app_info?.app_url);
                    // console.log("new response", categoryApiResponse);

                    // console.log("responseCategory=> " + response?.list_of_categories)

                    if (
                        categoryApiResponse?.list_of_category &&
                        categoryApiResponse.list_of_category.length > 0 &&
                        response?.list_of_categories &&
                        response.list_of_categories.length > 0
                    ) {
                        setSelectedCategory(categoryApiResponse.list_of_category);
                        console.log(
                            "Selected categories set:",
                            categoryApiResponse.list_of_category
                        );
                        const firstCategoryId = response.list_of_categories[0].id;
                        const matchingCategory = categoryApiResponse.list_of_category.find(
                            category => category.id === firstCategoryId
                        );
                        if (matchingCategory) {
                            setSelectedCategoryId(matchingCategory.id);
                        } else {
                            // console.error("Matching category not found in API response");
                        }
                    } else {
                        // console.error("Category list not found in API response");
                        setSelectedCategory(categoryApiResponse.list_of_category);
                        // Handle the case when the category list is not available in the API response
                    }
                } catch (e: any) {
                    toast.error(e);
                }
            } catch (error) {
                console.log("Fetched dashboard dataError:");
                console.error("Error fetching dashboard data:", error);
                toast.error("Error fetching data");
            }
        };

        // Fetch data only if appsResponseData is undefined or empty
        if (!data) {
            fetchData();
        } else {

            setAppName(data.app_name);
            setShortDescription(data.short_description);
            setAppTitle(data.app_info.title);
            setAppDescription(data.app_info.description);
            setSelectedResponseCategory(data?.list_of_categories);
            // setSelectedCategory(data.list_of_categories || []);
            setBanners(data?.banners);
            setSelectedLanguage(data?.selectedLanguage);
            const featuresFromData: string[] = data?.app_info?.features || [];
            setFeatures(featuresFromData);
            // Initialize featureValues with empty strings for each feature
            setFeatureValues(Array(featuresFromData.length).fill(""));
            setAppIconsUrl(data.app_icon);
            setSubmitStatus(data?.status || "");
            const supportNumber = data?.support_info?.support_number;
            if (supportNumber) {
                // Check if the support number starts with "+91"
                const formattedSupportNumber = supportNumber.startsWith("+91")
                    ? supportNumber.substring(3)
                    : supportNumber;
                setContactNumber(formattedSupportNumber);
            } else {
                // If the support number is null or undefined, set an empty string
                setContactNumber("");
            }

            setContactEmail(data?.support_info.support_email);
            setsupportUrl( data?.support_info?.support_url)
            
            settitleTag(data?.seo_details?.title_tag)
            setMetaDescription(data?.seo_details?.meta_description)
            
            localFetchCategory()

            // Set state variables from the fetched data
        }
    }, [dispatch, appID, data]);

    const localFetchCategory = async () => {
        const categoryApiResponse = await listOfCategory();
        if (
            categoryApiResponse?.list_of_category &&
            categoryApiResponse.list_of_category.length > 0 &&
            data?.list_of_categories &&
            data.list_of_categories.length > 0
        ) {
            setSelectedCategory(categoryApiResponse.list_of_category);
            console.log(
                "Selected categories set:",
                categoryApiResponse.list_of_category
            );
            const firstCategoryId = data.list_of_categories[0].id;
            const matchingCategory = categoryApiResponse.list_of_category.find(
                category => category.id === firstCategoryId
            );
            if (matchingCategory) {
                setSelectedCategoryId(matchingCategory.id);
            } else {
                console.error("Matching category not found in API response");
            }
        } else {
            setSelectedCategory(categoryApiResponse.list_of_category);
            console.error("Category list not found in API response");
            // Handle the case when the category list is not available in the API response
        }
    }
    ///category
    const [selected, setSelected] = useState("name");
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isIconPopupOpen, setIconPopupOpen] = useState(false);

    const handleSelectChange = useCallback(
        (selectedCategoryId: string) => {
            const selectedCategoryObject = selectedCategory.find(
                (category) => category.id === selectedCategoryId
            );
            console.log(selectedCategoryId + " " + selectedCategoryObject?.name);
            setSelectedCategoryId(selectedCategoryId);
            if (selectedCategoryObject) {
                setSelectedResponseCategory([selectedCategoryObject]);
            } else {
                setSelectedResponseCategory([]); // Clear the selected category if it's not found
            }
        },
        [selectedCategory]
    );

    const handleSelectChangelanguage = useCallback(
        (value: string) => setSelected(value),
        []
    );
    const optionsLanguage = [
        { label: "English", value: "English" },
        // { label: 'English(US)', value: 'English(US)' },
    ];

    const handleOpenModal = () => {
        setPopupOpen(true);
    };

    const handleCloseModal = () => {
        setPopupOpen(false);
    };

    const handleIconAddBanner = () => {
        // Check if the banner list length is less than 4
        try {
            if (banners.length <= 5 || []) {
                setIconPopupOpen(true);
                // Proceed with adding a new banner
                // For example, you can add a new banner to the 'banners' state
                // For demonstration, let's assume you have a function to add a new banner
                // addToBannerList(newBanner);
                // Replace 'addToBannerList' and 'newBanner' with your actual implementation
                console.log("Adding a new banner");
            } else {
                // Display a message or perform any action if the banner list length is already 4
                console.log("Cannot add more than 4 banners");
                toast.error("Cannot add more than 4 banners");
            }
        } catch (e) {
            console.log(e);
            toast.error("Somthing went wrong");
        }
    };
    const handleIconCloseModal = () => {
        setIconPopupOpen(false);
    };

    // Function to handle saving configuration
    const handleSaveConfiguration = async () => {
        if (!appName.trim()) {
            setAppNameError("App Name is required");
            return;
        } else {
            setAppNameError("");
        }
        if (!shortDescription.trim()) {
            setShortDescriptionError("Short Description is required");
            return;
        } else {
            setShortDescriptionError("");
        }
        if (!appTitle.trim()) {
            setAppTitleError("App Title is required");
            return;
        } else {
            setAppTitleError("");
        }
        if (!appDescription.trim()) {
            setAppDescriptionError("App Description is required");
            return;
        } else {
            setAppDescriptionError("");
        }
        if (!contactNumber.trim()) {
            setContactNumberError("Contact number is required");
            return;
        } else {
            setContactNumberError("");
        }
        if (!contactEmail.trim()) {
            setContactEmailError("Contact email is required");
            return;
        } else {
            setContactEmailError("");
        }
        const resolvedCategoryId = selectedCategoryId || (selectedCategory[0] ? selectedCategory[0].id : null);

        if (!resolvedCategoryId) {
            toast.error("Category selection is required.");
            return;
        }
        const updatedFeaturesList = features.map((feature) => feature);

        console.log("Saved Configuration:");
        console.log("App Name:", appName);
        console.log("Short Description:", shortDescription);
        console.log("App Title:", appTitle);
        console.log("App Description:", appDescription);
        console.log("Features:");
        console.log("Features:", updatedFeaturesList);
        console.log("Selected Category:", selectedCategory);
        console.log("Selected Language:", selectedLanguage);
        console.log("Banners:", banners);


        const configData = {
            app_id: appID,
            app_info: {
                description: appDescription,
                title: appTitle,
                features: updatedFeaturesList,
            },

            short_description: shortDescription,
            supported_language: selectedLanguage ?? "English",
            support_info: {
                support_email: contactEmail,
                support_number: "+91" + contactNumber,
                support_url: supportUrl,
            },
            seo_details: {
                title_tag: titleTag,
                meta_description:metaDescription
            },
            app_name: appName,
            categories: [resolvedCategoryId],
        };

        console.log("Configuration data:", configData);

        // Perform the API call to save the configuration
        // You need to implement this function according to your API endpoint
        // For example:
        try {
            const saveResponse = await saveconfigurationsApi(configData);
            console.log(saveResponse);

            toast.success("Save Success");
        } catch (e: any) {
            toast.error(e.message);
        }
        // Display success message if the configuration is saved successfully
        // For example:
    };

    if (loading) {
        return (
            <div
                className="developer-page-frame"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    height: "100vh",
                }}
            >
                <Spinner size="large" />
                <div style={{ marginTop: "20px" }}>
                    <a>Please wait...</a>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="developer-page-frame"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Banner>{error}</Banner>
            </div>
        );
    }

    return (
        <>
            <div className="developer-page-frame" style={{ backgroundColor: "#f6f6f7", paddingLeft: "2.0rem", paddingRight: "2.0rem", paddingTop: "25px" }}>
                <ToastContainer style={{ paddingTop: "50px" }} />{" "}
                {/* Add ToastContainer here */}
                <div >
                    <label style={{ fontFamily: "sfprobold", fontSize: "20px", lineHeight: "revert" }} className="font-medium text-base">
                        App Listing
                    </label>

                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600", }}
                            className="font-medium text-base w-full sm:w-48"
                        >
                            App Name
                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div >
                                    <div className="label-text" style={{ paddingBottom: "15px" }}>
                                        <TextField
                                            maxLength={32}
                                            showCharacterCount
                                            label="App Name"
                                            autoComplete="App Name"
                                            placeholder="Enter App Name"
                                            value={appName}
                                            onChange={(newValue) => {
                                                setAppName(newValue);
                                                setAppNameError(""); // Clear the error state
                                            }}
                                        />

                                        {appNameError && (
                                            <span style={{ color: "red" }}>{appNameError}</span>
                                        )}
                                    </div>
                                    <div>
                                        <div >
                                            {selectedCategory.length > 0 ? (<div className="label-text">
                                                <Label id={""}>Select Category</Label>
                                            </div>) : (<></>)}
                                            {selectedCategory.length > 0 ? (
                                                <Select
                                                    label
                                                    labelInline
                                                    options={selectedCategory.map((category) => ({
                                                        label: category.name,
                                                        value: category.id,
                                                    }))}
                                                    onChange={handleSelectChange}
                                                    value={
                                                        selectedCategory.find(
                                                            (category) =>
                                                                category.id === selectedResponseCategory[0]?.id
                                                        )?.id || ""
                                                    }
                                                />
                                            ) : (
                                                <p>No categories available</p>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </Card>
                        </div>
                    </div>



                    <div style={{ paddingTop: "40px" }}>
                        <Divider />
                    </div>
                </div>
                <div
                    style={{ paddingTop: "10px" }}
                    className="container"
                >

                    {/* app icon */}
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48"
                        >
                            App Setting
                        </label>
                        <div className="w-full sm:w-2/3  ">
                            <Card>
                                <div >
                                    <div>
                                        <label
                                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                            className="font-medium text-base w-full sm:w-48"
                                        >
                                            App Icon
                                        </label>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: "80px",
                                                    height: "80px",
                                                    marginTop: "20px",
                                                }}
                                                src={appIconUrl || defaultAppIcon}
                                            ></img>
                                            <div style={{ marginTop: "40px" }}>
                                                <button
                                                    style={{
                                                        border: "1px solid grey", // You can adjust the border width and color as needed
                                                        borderRadius: "0", // Set border radius to 0 for rectangle border
                                                        padding: "10px 20px", // Adjust padding as needed
                                                        backgroundColor: "transparent", // Transparent background
                                                        color: "#333", // Text color
                                                        cursor: "pointer", // Show pointer cursor on hover
                                                        outline: "none",
                                                    }}
                                                    onClick={
                                                        submitStatus !== "Submitted" &&
                                                            submitStatus !== "Reviewed"
                                                            ? handleOpenModal
                                                            : undefined
                                                    }
                                                >
                                                    Edit
                                                </button>

                                                {isPopupOpen && (
                                                    <DevUploadIcon
                                                        open={isPopupOpen}
                                                        onClose={handleCloseModal}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                    {/* app name and tittle */}
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48"
                        >

                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div >
                                    <div style={{ paddingBottom: "15px" }}>
                                        <TextField
                                            label="App Card Description"
                                            autoComplete="App tittle"
                                            maxLength={100}
                                            showCharacterCount
                                            placeholder="Enter App tittle"
                                            value={appTitle}
                                            onChange={(newValue) => {
                                                setAppTitle(newValue);
                                                setAppTitleError(""); // Clear the error state
                                            }}
                                        />
                                        {appTitleError && (
                                            <span style={{ color: "red" }}>{appTitleError}</span>
                                        )}
                                    </div>

                                    <div style={{ paddingBottom: "15px" }}>
                                        <TextField
                                            maxLength={100}
                                            showCharacterCount
                                            label="App Introduction"
                                            autoComplete="Short Description"
                                            placeholder="Enter Short Description"

                                            value={shortDescription}
                                            onChange={(newValue) => {
                                                setShortDescription(newValue);
                                                setShortDescriptionError(""); // Clear the error state
                                            }}
                                        />
                                        {shortDescriptionError && (
                                            <span style={{ color: "red" }}>{shortDescriptionError}</span>
                                        )}
                                    </div>

                                    <TextField
                                        maxLength={500}
                                        showCharacterCount
                                        label="App Description"
                                        autoComplete="App Discription"
                                        placeholder="Enter App Discription"
                                        multiline={4}
                                        value={appDescription}
                                        onChange={(newValue) => {
                                            setAppDescription(newValue);
                                            setAppDescriptionError(""); // Clear the error state
                                        }}
                                    />
                                    {appDescriptionError && (
                                        <span style={{ color: "red" }}>{appDescriptionError}</span>
                                    )}
                                </div>
                            </Card>
                        </div>
                    </div>
                    {/* supoorted Languages */}
                    <div
                        style={{ paddingTop: "10px" }}
                        className="container"
                    >
                        <div className="pt-9 flex flex-col sm:flex-row gap-8">
                            <label
                                style={{ fontFamily: "sfpromedium", fontWeight: "400" }}
                                className="font-medium text-base w-full sm:w-48"
                            ></label>{" "}
                            <div className="w-full sm:w-2/3 ">
                                <Card>
                                    <div   >
                                        <div style={{ paddingBottom: "15px" }}>
                                            <label
                                                style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                                className="font-medium text-base w-full sm:w-48"
                                            >
                                                Supported Language
                                            </label>
                                        </div>
                                        <div style={{ paddingBottom: "10px" }} >
                                            <Select
                                                label
                                                labelInline
                                                options={optionsLanguage}
                                                onChange={handleSelectChangelanguage}
                                                value={selected}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <h1 style={{ margin: 0 }}>{"(View this "}</h1>
                                        <a href="https://www.google.com" target="_blank" rel="noopener noreferrer" style={{ margin: "0 5px", color: 'blue', textDecoration: 'underline' }}>
                                            {" Image "}
                                        </a>
                                        <h1 style={{ margin: 0 }}>{" to understand the content Placement)"}</h1>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>

                    <div style={{ paddingTop: "40px" }}>
                        <Divider />
                    </div>
                    {/* features */}
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48"
                        >
                            App Features
                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <div
                                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                            className="font-medium text-base"
                                        >
                                            App Features
                                        </div>
                                        {features.length < MAX_FEATURES && (
                                            <div>
                                                <Button onClick={() => setFeatures([...features, ""])}>
                                                    Add Feature
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                    {features.map((feature, index) => (
                                        <div key={index} style={{ marginBottom: index !== features.length - 1 ? "20px" : "0px" }}>
                                            <TextField
                                                maxLength={150}
                                                showCharacterCount
                                                label={`Feature ${index + 1}`}
                                                autoComplete=""
                                                placeholder="Enter your app feature"
                                                multiline={0}
                                                value={feature}
                                                onChange={(newValue) => {
                                                    const updatedFeatures = [...features];
                                                    updatedFeatures[index] = newValue;
                                                    setFeatures(updatedFeatures);
                                                }}
                                            />
                                        </div>
                                    ))}
                                    <div style={{ display: "flex", alignItems: "center", paddingTop: "10px" }}>
                                        <h1 style={{ margin: 0 }}>{"(View this "}</h1>
                                        <a href="https://www.google.com" target="_blank" rel="noopener noreferrer" style={{ margin: "0 5px", color: 'blue', textDecoration: 'underline' }}>
                                            {" Image "}
                                        </a>
                                        <h1 style={{ margin: 0 }}>{" to understand the content Placement)"}</h1>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>


                    <div style={{ paddingTop: "40px" }}>
                        <Divider />
                    </div>
                </div>
                {/* banner */}
                <div
                    style={{ paddingTop: "10px" }}
                    className="container"
                >

                </div>
                {/* banner components */}
                <div
                    style={{ paddingTop: "10px" }}
                    className="container"
                >
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48"
                        >
                            App Banners
                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                        <div
                                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                            className="font-medium text-base"
                                        >
                                            Banners
                                        </div>
                                        {
                                            banners.length>=5 || submitStatus === "Submitted" ||submitStatus === "Reviewed"?undefined:<Button onClick={
                                                submitStatus !== "Submitted" &&
                                                    submitStatus !== "Reviewed"
                                                    ? handleIconAddBanner
                                                    : undefined
                                            }>
                                                Add Banner
                                            </Button>
                                        }

                                        {isIconPopupOpen && (
                                            <DevUploadBanner
                                                open={isIconPopupOpen}
                                                onClose={handleIconCloseModal}
                                            />
                                        )}
                                    </div>

                                    <div >
                                        <DevImageList banners={banners ?? []} />
                                    </div>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", paddingTop: "15px" }}>
                                    <h1 style={{ margin: 0 }}>{"(View this "}</h1>
                                    <a href="https://www.google.com" target="_blank" rel="noopener noreferrer" style={{ margin: "0 5px", color: 'blue', textDecoration: 'underline' }}>
                                        {" Image "}
                                    </a>
                                    <h1 style={{ margin: 0 }}>{" to understand the content Placement)"}</h1>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
                <div style={{ paddingTop: "40px" }}>
                    <Divider />
                </div>
                {/* contact us */}
                <div
                    style={{ paddingTop: "10px" }}
                    className="container">
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48">
                            Supports Details
                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div >
                                    <div>
                                        <label
                                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                            className="font-medium text-base w-full sm:w-48">

                                        </label>
                                    </div>
                                    <div >

                                        <div>
                                            <TextField
                                                label={`Support URL`}
                                                autoComplete=""
                                                placeholder="Enter your url"
                                                value={supportUrl}
                                                onChange={(newValue) => {
                                                    setsupportUrl(newValue);
                                                    setSupportUrlError("");
                                                }}
                                            />
                                            {supportUrlError && (
                                                <span style={{ color: "red" }}>
                                                    {supportUrlError}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ paddingTop: "20px", }}>
                                            <TextField
                                                label={`Support email`}
                                                autoComplete=""
                                                placeholder="Enter your email"
                                                value={contactEmail}
                                                onChange={(newValue) => {
                                                    setContactEmail(newValue);
                                                    setContactEmailError("");
                                                }}
                                            />
                                            {contactEmailError && (
                                                <span style={{ color: "red" }}>
                                                    {contactEmailError}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ paddingTop: "20px", }}>

                                            <TextField
                                                label={`Support Contact`}
                                                autoComplete=""
                                                prefix="+91"
                                                inputMode="numeric" // Ensures numeric keyboard on mobile devices
                                                pattern="[0-9]{10}" // Ensures the input is exactly 10 digits
                                                placeholder="Enter contact number"
                                                value={contactNumber}
                                                onChange={(newValue) => {
                                                    const numericValue = newValue.replace(/\D/g, "").slice(0, 10);

                                                    setContactNumber(numericValue);
                                                    setContactNumberError("");
                                                    // setContactNumber(newValue);
                                                    // setContactNumberError("");
                                                }}
                                            />
                                            {contactNumberError && (
                                                <span style={{ color: "red" }}>{contactNumberError}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>

                {/* //Seo Tags */}
                <div
                    style={{ paddingTop: "10px" }}
                    className="container"
                >
                    <div className="pt-9 flex flex-col sm:flex-row gap-8">
                        <label
                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                            className="font-medium text-base w-full sm:w-48"
                        >
                            SEO Details
                        </label>
                        <div className="w-full sm:w-2/3">
                            <Card>
                                <div >
                                    <div>
                                        <label
                                            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "16px", fontWeight: "600" }}
                                            className="font-medium text-base w-full sm:w-48"
                                        >

                                        </label>
                                    </div>
                                    <div >

                                        <div>
                                            <TextField
                                                label={`Title Tag`}
                                                autoComplete=""
                                                placeholder="Enter your title tag"
                                                value={titleTag}
                                                onChange={(newValue) => {
                                                    settitleTag(newValue);
                                                    setTitleTagError("");
                                                }}
                                            />
                                            {titleTagError && (
                                                <span style={{ color: "red" }}>
                                                    {titleTagError}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ paddingTop: "20px", }}>
                                            <TextField
                                                label={`Meta Description`}
                                                autoComplete=""
                                                placeholder="Enter your meta description"
                                                value={metaDescription}
                                                onChange={(newValue) => {
                                                    setMetaDescription(newValue);
                                                    setMetaDescriptionError("");
                                                }}
                                            />
                                            {metaDescriptionError && (
                                                <span style={{ color: "red" }}>
                                                    {metaDescription}
                                                </span>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>


                {submitStatus !== "Submitted" && submitStatus !== "Reviewed" ? (
                    <div
                        style={{ marginTop: "30px", paddingRight: "90px" }}
                        className="flex justify-end"
                    >
                        <button className="button" onClick={handleSaveConfiguration}>
                            <Text variant="bodyMd" as="p">
                                Save Configuration
                            </Text>
                        </button>
                    </div>
                ) : (
                    <div style={{ direction: "rtl", paddingTop: "20px", color: "green" }}>
                        <label
                            style={{
                                paddingTop: "50px",
                                paddingRight: "150px",
                                justifyContent: "end",
                                fontSize: "20",
                            }}
                        >
                            Your App {submitStatus} Successfully
                        </label>
                    </div>
                )}
                <div style={{ height: "60px" }}></div>
            </div>
        </>
    );

}


